<template>
  <div class="lipi">
    <!-- Header - start -->
    <div class="header">
      <a class="nav-item join" style="font-weight: bold;" href="#join">{{verses.topbar.join}}</a>
      <a class="nav-item pricing" href="#pricing-retail">{{verses.topbar.pricing}}</a>
      <a class="nav-item features" href="#features">{{verses.topbar.features}}</a>
      <div class="nav-item empty-space"></div>
      <a target="_blank" href="https://github.com/anvilglobaldynamics/torque">
        <img  src="../assets/github-logo.png" style="height: 32px; padding-left: 6px; padding-top: 10px;" />
      </a>
      <!-- <a class="nav-item home" href="/">{{verses.topbar.home}}</a> -->
    </div>
    <!-- Header - end -->

    <!-- Content - start -->
    <div class="content">
      <!-- Content: Landing - start -->
      <div class="page landing column center-main center-cross" id="landing">
        <div class="language-selector">
          <img
            src="../assets/en-us.png"
            @click="setLanguage('en-us')"
            v-bind:class="{ active: (selectedLanguage==='en-us') }"
            alt="Lipi for Business in English Language" 
          />
          <img
            src="../assets/bn-bd.png"
            @click="setLanguage('bn-bd')"
            v-bind:class="{ active: (selectedLanguage==='bn-bd') }"
            alt="Lipi for Business in Bengali/Bangla Language"
          />
        </div>
        <!-- <div class="partner">
          <img src="../assets/partners/gcloud.png" alt="Data of Lipi for Business is hosted securely on google cloud." />
        </div> -->
        <div class="hero-unit morphing-row">
          <div class="column">
            <div class="lipi-logo-container">
              <img class="lipi-logo" src="../assets/logo.png" alt="Logo of Lipi for Business, a robust and lightweight business management solution" />
            </div>
          </div>
          <div class="column">
            <div class="description-title">{{verses.hero.tagline}}</div>

            <div class="description important">
              <span>{{verses.hero.descriptionPartOne}}</span> <br>
              <span>{{verses.hero.descriptionPartTwo}}</span>
            </div>

            <div class="primary-button-container features-button-container register-with-phone-container" v-if="!isPlatformAndroid">
              <!-- <input class="register-with-phone-input" v-model="phone" :placeholder="placeholder"> -->
              <a class="register-with-phone-button primary-button" @click="registerClicked">{{verses.hero.registerWithPhoneButton}}</a>
            </div>

            <div class="primary-button-container features-button-container" v-if="isPlatformAndroid">
              <a class="primary-button" 
                target="_blank"
                rel="noopener"
                href="https://lipi.live/getlipi?ref=lipi"
              >{{verses.hero.freeMobileApp}}</a>              
              <a class="secondary-button" href="#features" style="margin-left: 20px;" >{{verses.hero.featuresLink}}</a>
            </div>

            <div class="scroll-down-area" @click="scrollDownClicked" v-if="!isPlatformAndroid">
              <div class="scroll-down-label">{{verses.hero.scrollToLearnMore}}</div>
              <img class="scroll-down-icon" src="../assets/scroll-down.png" alt="Scroll Down" />
            </div>

          </div>
        </div>

        <div class="primary-button-container features-button-container register-with-phone-container register-with-phone-container-tab-only" v-if="!isPlatformAndroid">
          <!-- <input class="register-with-phone-input" v-model="phone" :placeholder="placeholder"> -->
          <a class="register-with-phone-button primary-button" @click="registerClicked">{{verses.hero.registerWithPhoneButton}}</a>
        </div>

        <div class="social-proof">
          <div class="user-count-container">
            <div class="user-account-title">{{verses.hero.socialProofUserAccountTitle}}</div>
            <div class="user-account-text">{{verses.hero.socialProofUserAccountText}}</div>
          </div>
          <div class="google-play-rating-container">
            <div class="google-play-stars">
              <img class="google-play-star-icon" src="../assets/star.png" />
              <img class="google-play-star-icon" src="../assets/star.png" />
              <img class="google-play-star-icon" src="../assets/star.png" />
              <img class="google-play-star-icon" src="../assets/star.png" />
              <img class="google-play-star-icon" src="../assets/half-star.png" />
            </div>
            <div class="google-play-rating-text-container">
              <img class="google-play-rating-logo" src="../assets/google-play-review.png" />
              <span class="google-play-rating-text">{{verses.hero.socialProofGooglePlayRating}}</span>
            </div>
          </div>
          <div class="gmv-with-stock-container">
            <div class="gmv-with-stock-title">{{verses.hero.socialProofGmvWithStockTitle}}</div>
            <div class="gmv-with-stock-text">{{verses.hero.socialProofGmvWithStockText}}</div>
          </div>
        </div>

        <div class="google-play-rating-container-mobile-only">
          <div class="google-play-stars">
            <img class="google-play-star-icon" src="../assets/star.png" />
            <img class="google-play-star-icon" src="../assets/star.png" />
            <img class="google-play-star-icon" src="../assets/star.png" />
            <img class="google-play-star-icon" src="../assets/star.png" />
            <img class="google-play-star-icon" src="../assets/half-star.png" />
          </div>
          <div class="google-play-rating-text-container">
            <img class="google-play-rating-logo" src="../assets/google-play-review.png" />
            <span class="google-play-rating-text">{{verses.hero.socialProofGooglePlayRating}}</span>
          </div>
        </div>

        <!-- <img alt="Loading..." class="hero-image" src="https://placeimg.com/800/400/tech" /> -->
      </div>
      <!-- Content: Landing - end -->

      <!-- Content: Features  - start -->
      <div class="page features column center-cross" id="features">

        <div class="feature-container">
          
          <div class="feature">
            <div class="text-container text-on-left-side">
              <div class="card-title">
                {{verses.features.inventoryManagementCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.inventoryManagementLineOne}}
              </div>
              <div class="card-text">
                {{verses.features.inventoryManagementLineTwo}}
              </div>
              <div class="card-text">
                {{verses.features.inventoryManagementLineThree}}
              </div>
            </div>
            <div class="video-container">
              <iframe src="https://www.youtube.com/embed/2lxwzfWwqcw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>

          <div class="feature">
            <div class="video-container hide-on-smartphone">
              <iframe src="https://www.youtube.com/embed/VIT_ihUgF9o" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="text-container text-on-right-side">
              <div class="card-title">
                {{verses.features.AccountingAndReportsCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.AccountingAndReportsLineOne}}
              </div>
              <div class="card-text">
                {{verses.features.AccountingAndReportsLineTwo}}
              </div>
              <div class="card-text-small">
                {{verses.features.AccountingAndReportsLineThree}}
              </div>
            </div>
            <div class="video-container hide-on-desktop">
              <iframe src="https://www.youtube.com/embed/VIT_ihUgF9o" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div> 

          <div class="feature">
            <div class="text-container text-on-left-side">
              <div class="card-title">
                {{verses.features.vendorEmployeeCustomerCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.vendorEmployeeCustomerLineThree}}
              </div>
              <div class="card-text">
                {{verses.features.vendorEmployeeCustomerLineTwo}}
              </div>
              <div class="card-text">
                {{verses.features.vendorEmployeeCustomerLineOne}}
              </div>
            </div>
            <div class="video-container">
              <iframe src="https://www.youtube.com/embed/-YAITo43Zw4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>

          <div class="feature">
            <div class="video-container hide-on-smartphone">
              <iframe src="https://www.youtube.com/embed/EdMsj2a0MNM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="text-container text-on-right-side">
              <div class="card-title">
                {{verses.features.liveAlwaysEverywhereCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.liveAlwaysEverywhereLineOne}}
              </div>
              <div class="card-text">
                {{verses.features.liveAlwaysEverywhereLineThree}}
              </div>
            </div>
            <div class="video-container hide-on-desktop">
              <iframe src="https://www.youtube.com/embed/EdMsj2a0MNM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>

          <div class="feature">
            <div class="text-container text-on-left-side">
              <div class="card-title">
                {{verses.features.openSourceCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.openSourceLineOne}}
              </div>
              <div class="card-text">
                {{verses.features.openSourceLineTwo}}
              </div>
              <a class="card-a-tag" target="_blank" href="https://github.com/anvilglobaldynamics/torque">
                {{verses.features.openSourceLinkLineText}}
              </a>
            </div>

            <div style="flex-grow: 1"></div>

            <div class="text-container pos-feature" style="text-align: right">
              <div class="card-title">
                {{verses.features.posDigitalInvoicingCardTitle}}
              </div>
              <div class="card-text">
                {{verses.features.posDigitalInvoicingLineOne}}
              </div>
              <div class="card-text">
                {{verses.features.posDigitalInvoicingLineTwo}}
              </div>
              <a class="card-a-tag" target="_blank" href="https://medium.com/@notnowshad/digital-receipts-and-lipi-lite-b16f2eec48ff">
                {{verses.features.posDigitalInvoicingLineThree}}
              </a>
            </div>
          </div>

        </div>  

      </div>
      <!-- Content: Features - end -->

      <!-- Content: Pricing-retail - start -->
      <div class="page pricing-retail morphing-row center-cross center-main" id="pricing-retail">

        <div class="left-testimonials-column column">

          <div class="testimonial-column-title">
            {{verses.testimonials.title}}
            </div>

          <div class="testimonial-block row">
            <div class="testimonial-text-block">
              <div class="testimonial-title">{{verses.testimonials.testimonial1Title}}</div>
              <div class="testimonial-subtitle">{{verses.testimonials.testimonial1Subtitle}}</div>
              <div class="testimonial-text">{{verses.testimonials.testimonial1Text}}</div>
            </div>
            <img class="testimonial-photo" src="../assets/testimonial-photo-1.jpg">
          </div>

          <div class="testimonial-block row left-aligned">
            <img class="testimonial-photo" src="../assets/testimonial-photo-2.jpg" style="margin-left: 0px;">
            <div class="testimonial-text-block">
              <div class="testimonial-title">{{verses.testimonials.testimonial2Title}}</div>
              <div class="testimonial-subtitle">{{verses.testimonials.testimonial2Subtitle}}</div>
              <div class="testimonial-text">{{verses.testimonials.testimonial2Text}}</div>
            </div>
          </div>

          <div class="testimonial-block row">
            <div class="testimonial-text-block">
              <div class="testimonial-title" >{{verses.testimonials.testimonial3Title}}</div>
              <div class="testimonial-subtitle">{{verses.testimonials.testimonial3Subtitle}}</div>
              <div class="testimonial-text">{{verses.testimonials.testimonial3Text}}</div>
            </div>
            <img class="testimonial-photo" src="../assets/testimonial-photo-3.jpg">
          </div>
          
        </div>

        <div class="right-pricing-colum column">

          <div class="row pricing-block-main-title">
            {{ verses.pricing.pricingMainTitle }} 
          </div>

          <div class="column pricing-block-main">
            <div class="pricing-terms-new">
              <div class="pricing-terms-new-item">
                <img src="../assets/star-small.png" />
                {{ verses.pricing.lineOne }}
              </div>
              <div class="pricing-terms-new-item">
                <img src="../assets/star-small.png" />
                {{ verses.pricing.lineTwo }}
              </div>
              <div class="pricing-terms-new-item">
                <img src="../assets/star-small.png" />
                {{ verses.pricing.lineThree }}
              </div>
              <div class="pricing-terms-new-item">
                <img src="../assets/star-small.png" />
                {{ verses.pricing.lineFour }}
              </div>
            </div>
          </div>

          <div class="primary-button-container" style="margin-bottom: 30px; margin-top: 30px; margin-left: 14px;">
            <a class="primary-button" href="https://app.lipi.live/#/register?ref=lipi" target="_blank">
              {{ verses.about.lineTwoPartTwo }}
            </a>
          </div>

          <div class="row pricing-block-free-title">
            {{ verses.pricing.pricingFreeTitle }} 
          </div>

          <div class="column pricing-block-free">
            <div class="pricing-terms">
              <ul>
                <li>{{ verses.pricing.freeLineOne }}</li>
                <li>{{ verses.pricing.freeLineTwo }}</li>
              </ul>
            </div>
          </div>

        </div>

      </div>
      <!-- Content: Pricing-retail - end -->

      <!-- Content: Lite - start -->
      <div class="page lipi-lite column center-main center-cross" id="lipi-lite">
        <div class="lipi-lite-container">
          <div class="lipi-lite-title">{{verses.lipiLite.title}}</div>

          <!-- English area - start -->
          <div  v-if="selectedLanguage==='en-us'">
            <div class="lipi-lite-body-one">
              <span class="colored-body-text">Lipi </span> 
              comes with all the essential features for retail businesses. 
              It works on your Computer and Android phone. So, you can run your business from anywhere.
            </div>

            <div class="lipi-lite-body-two">
              Download the app from
              <span class="colored-body-text">Google Play Store</span> 
              and start running your business.
            </div>
          </div>
          <!-- English area - end -->

          <!-- Bangla area - start -->
          <div  v-if="selectedLanguage==='bn-bd'">
            <div class="lipi-lite-body-one">
              দোকান চালানর জন্য প্রয়োজনীয় সকল ফীচার আছে  <span class="colored-body-text">লিপি </span>অ্যাপে। 
              <span class="colored-body-text"> লিপি </span> আপনার স্মার্টফোন এবং কম্পিউটারে কাজ করে, তাই আপনি ব্যবসা চালাতে পারবেন যেকোনো সময় - যেকোনো জায়গা থেকে।  
            </div>
            
            <div class="lipi-lite-body-two">
              <span class="colored-body-text">অ্যাপ স্টোর</span> থেকে নামিয়ে নিন এবং আপনার ব্যবসা <span class="colored-body-text">Lipi for Business</span> দিয়ে চালানো শুরু করুন। 
            </div>
          </div>
          <!-- Bangla area - end -->

          <div class="lipi-lite-action-container">
            <a
              target="_blank"
              rel="noopener"
              href="https://lipi.live/getlipi?ref=lipi"
            >
              <img src="../assets/google-play-badge.png" height="100" width="260" alt="Download Lipi Lite on Google Play Store and start sending Digital Receipts" />
            </a>
          </div>

          <!-- NOTE: This image is for SEO only! This does not appear on the website -->
          <div style="display:none;">
            <img src="../assets/lipi-lite-screenshot.png" alt="Lipi Lite, Free App to Send Digital Receipt. Download on Android to use CRM and Sales Report." />
          </div>

        </div>
      </div>
      <!-- Content: Join - end -->

      <!-- Content: Join - start -->
      <div class="page join morphing-row center-main center-cross" id="join">

        <div class="left-members-column column">

          <div class="member-column-title">
            {{verses.members.title}}
          </div>

          <div class="member-block row">
            <div class="member-text-block" style="text-align: right;">
              <div class="member-title">{{verses.members.member1Title}}</div>
              <div class="member-text">{{verses.members.member1Text}}</div>
            </div>
            <img class="member-photo" src="../assets/member-photo-1.jpg">
          </div>

          <div class="member-block row">
            <img class="member-photo" src="../assets/member-photo-2.jpg">
            <div class="member-text-block">
              <div class="member-title">{{verses.members.member2Title}}</div>
              <div class="member-text">{{verses.members.member2Text}}</div>
            </div>
          </div>
          
        </div>

        <div class="join-us-container column">

          <div class="view-app-container">
            {{ verses.about.lineTwoPartOne }}

            <div class="primary-button-container">
              <a class="primary-button" href="https://app.lipi.live/#/register?ref=lipi" target="_blank">
                {{ verses.about.lineTwoPartTwo }}
              </a>
            </div>
            
          </div>

          <div class="join-us-title">
            {{ verses.about.lineOne }}
          </div>

          <div class="join-us-detail">
            <p class="phone">{{ verses.general.lipiPhone }}</p>
            <p class="or">{{ verses.general.or }}</p>
            <p class="email">{{ verses.general.email }}</p>
          </div>

          <div class="social">
            <a href="https://www.youtube.com/channel/UCoHD2HTSQlU884oKQE7HB2Q" target="_blank">
              <img src="./../assets/social/youtube.png" alt="View videos of Lipi for Business on Youtube" />
            </a>
            <a href="https://www.facebook.com/LipiForBusiness" target="_blank">
              <img src="./../assets/social/facebook.png" alt="Connect with Lipi for Business on Facebook" />
            </a>
            <a href="https://www.instagram.com/lipiforbusiness" target="_blank">
              <img src="./../assets/social/instagram.png" alt="Connect with Lipi for Business on Instagram" />
            </a>
            <a href="https://www.linkedin.com/company/lipiforbusiness" target="_blank">
              <img src="./../assets/social/linkedin.png" alt="Connect with Lipi for Business on LinkedIn" />
            </a>
          </div>

        </div>
      </div>
      <!-- Content: Join - end -->
    </div>
    <!-- Content - end -->

    <footer class="footer">
      {{ verses.footer.lineOne }}
      <br />{{ verses.footer.lineTwo }}
    </footer>
  </div>
</template>

<style lang="scss" scoped>
@import "../styles/variables.scss";
@import "../styles/utils.scss";

/* 
  Notes:
  1. Previous feature area color - #0082c9;
*/

/* ========================= Generic / Common / Reusable ======================= */

.primary-button-container {
  margin-top: 30px;
  font-size: 16px;
}

.primary-button {
  color: white;
  background-color: #ff7043;
  padding: 10px 20px 10px 20px;
  border-radius: 4px;
  text-decoration: none;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
}

.primary-button:hover {
  background-color: #f4511e;
}

.primary-button:active {
  background-color: var(--theme-color-light);
}

.secondary-button {
  color: #D84315;
  background-color: #FFCCBC;
  padding: 10px 20px 10px 20px;
  border-radius: 4px;
  text-decoration: none;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.6);
}

.secondary-button:hover {
  color: white;
  background-color: #f4511e;
}

/* ========================= Header ======================= */

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row-reverse;
  background: var(--color-whitesmoke);
  height: 50px;
  z-index: 100;

  .nav-item {
    color: var(--clickable-text-color-dark);
    margin: 15px 10px 15px 10px;
    cursor: pointer;
    text-decoration: none;
  }

  .nav-item:hover {
    color: var(--theme-color-light);
  }

  .nav-item:active {
    color: var(--theme-color-light);
  }

  .nav-item.empty-space {
    flex: 1;
    cursor: auto;
  }
}

/* ========================= Page ======================= */

.page {
  min-height: calc(100vh - 100px);
  padding-top: 80px;
  padding-bottom: 50px;
}

/* ========================= Page: Landing ======================= */

.page.landing {
  margin-top: 52px;
  padding-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 560px) {
    justify-content: flex-start;
  }

  // background-color: var(--app-primary-color-light);

  background: linear-gradient(
      135deg,
      var(--app-primary-color-light) 0%,
      var(--app-primary-color-light) 10%,
      transparent 10%,
      transparent 100%
    ),
    linear-gradient(
      -45deg,
      var(--app-primary-color-light) 0%,
      var(--app-primary-color-light) 10%,
      white 10%,
      white 100%
    );

  .hero-unit {
    max-width: 1200px;

    .column {
      margin: 20px;
    }

    .description-title {
      color: #262838;
      font-size: 32px;
      margin-top: 6px;
    }

    .description.important {
      font-size: 20px;
      margin-top: 14px;
      margin-bottom: 14px;
    }
  }

  @media (max-width: 560px) {
    .hero-unit {
      margin-bottom: 12px;

      .column {
        margin: 8px;
      }

      .description-title {
        color: #262838;
        font-size: 22px;
        margin: 0px 0px 10px 10px;
        text-align: center;
      }

      .description.important {
        font-size: 14px;
        margin: 0px 10px 0px 10px;
        text-align: center;
      }

      .features-button-container {
        text-align: center;
        margin-left: 10px;
        // border: 1px red solid;
      }
    }
  }

  .lipi-logo {
    width: 240px;
    height: 240px;
  }

  .lipi-logo-container {
    margin-bottom: 20px;
  }

  @media (max-width: 560px) {
    .lipi-logo {
      width: 100px;
      height: 100px;
      margin: 10px;
      margin-bottom: 10px;
      margin-top: 18px;
    }

    .lipi-logo-container {
      margin: 0px;
    }
  }

  .hero-image {
    margin: 8px;
    width: calc(100vw - 16px);
    height: calc((100vw - 16px) / 2);
    max-width: 800px;
    max-height: 400px;
  }

  .language-selector {
    position: absolute;
    right: 32px;
    top: 105px;

    img {
      height: 28px;
      margin-right: 8px;
      cursor: pointer;
    }

    img.active {
      border-bottom: 2px solid var(--app-primary-color);
    }
  }

  .partner {
    position: absolute;
    right: 32px;
    top: 72px;

    img {
      height: 56px;
    }

    @media (max-width: 560px) {
      right: 16px;
      img {
        height: 32px;
      }
    }
  }

  .register-with-phone-container{
    margin-top: 6px;
  }

  .register-with-phone-input{
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 11px;
    padding-bottom: 11px;

    margin-left: 0px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-right: 12px;

    // box-sizing: border-box;  
    font-size: 18px;
    width: 260px;
    
    border-radius: 4px;
    border: 2px solid #009688;
  }

  .register-with-phone-button{
    display: inline-block;
    font-size: 22px;
    cursor: pointer;
  }

  .register-with-phone-input:focus {
    // border: 2px solid #D84315;
  }

  .register-with-phone-container-tab-only{
    display: none;
  }

  .scroll-down-area{
    text-align: center;
    position: absolute;
    bottom: 20px;
    left: calc(50% - (76px / 2));
    cursor: pointer;
    opacity: 0.6;
  }

  .scroll-down-label{
    color: black;
  }

  .scroll-down-icon{
    margin-top: 0px;
    width: 32px;
    height: 32px;
    opacity: 0.5;
  }

  .scroll-down-area:hover{
    opacity: 1;
  }

  @media (max-width: 768px) {

    .scroll-down-area{
      display: none;
    }

    .register-with-phone-input{
      display: inline-block;
      margin-right: 0px;
    }

    .register-with-phone-button{
      display: inline-block;
      margin-left: 0px;
      font-size: 18px;
      cursor: pointer;
    }

    .register-with-phone-container{
      margin-top: 26px;
      text-align: center;
      margin-left: 0px !important;
    }

  }

  // Only for iPad
  @media (min-width: 561px) and (max-width: 768px) {
    .register-with-phone-container {
      display: none;
      margin-top: 12px;
      margin-bottom: 30px;
    }
    .register-with-phone-container-tab-only {
      display: block;
      .register-with-phone-button{
        font-size: 22px;
        cursor: pointer;
      }
    }
    .register-with-phone-input{
      margin-right: 8px;
    }
  }

  // social proof - start

  .social-proof{
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1100px;
    text-align: center;
    // color: #262838;
    margin-top: 30px;
  }

  .social-proof > div{
    width: 33%;
  }

  .user-account-title{
    font-size: 60px;
    line-height: 60px;
  }

  .user-account-text{
    font-size: 21px;
  }

  .gmv-with-stock-title{
    font-size: 50px;
    line-height: 58px;
  }

  .gmv-with-stock-text{
    font-size: 21px;
  }

  .google-play-rating-container{
    margin-top: 8px;
  }

  .google-play-stars{
    margin-left: 4px;
  }

  .google-play-star-icon{
    height: 38px;
    width: 38px;
    margin-right: 4px;
  }

  .google-play-rating-text-container{
    margin-top: 8px;
    display: flex;
    align-items:center;
    justify-content:center;
  }

  .google-play-rating-text{
    // color: #262838;
    font-size: 21px;
  }

  .google-play-rating-logo{
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
  
  .google-play-rating-container-mobile-only{
    display: none;
  }

  @media (max-width: 768px) {

    .social-proof{
      margin-top: 15px;
    }

    .social-proof > div{
      width: 50%;
    }

    .google-play-rating-container{
      display: none;
    }

    .google-play-rating-container-mobile-only{
      margin-top: 20px;
      display: block;
    }

    .user-account-title{
      font-size: 30px;
      line-height: 30px;
    }

    .user-account-text{
      font-size: 12px;
    }

    .gmv-with-stock-title{
      font-size: 30px;
      line-height: 30px;
    }

    .gmv-with-stock-text{
      font-size: 12px;
    }

    .google-play-star-icon{
      height: 20px;
      width: 20px;
      margin-right: 4px;
    }

    .google-play-rating-text-container{
      margin-top: 0px;
    }

    .google-play-rating-logo{
      height: 16px;
      width: 16px;
      margin-right: 6px;
    }

    .google-play-rating-text{
      font-size: 12px;
    }

  }

  // social proof - end
}

/* ========================= Page: Pricing-retail ======================= */

.page.pricing-retail {
  background-color: #004D40;

  background: linear-gradient(
    -45deg,
    white 0%,
    white 10%,
    #004D40 10%,
    #004D40 100%
  );

  // .title {
  //   align-self: center;
  //   padding-bottom: 6px;
  //   font-weight: bold;
  //   font-size: 30px;
  //   color: var(--color-whitesmoke);
  // }

  // .subtitle {
  //   align-self: center;
  //   font-size: 22px;
  //   color: var(--color-whitesmoke);
  // }

  // .price {
  //   // font-family: Helvetica;
  //   align-self: center;
  //   font-weight: bold;
  //   font-size: 70px;
  //   color: var(--color-whitesmoke);

  //   .value {
  //     font-family: Signika;
  //     color: #ff7043;
  //     text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
  //   }

  //   .monetary-unit {
  //     font-size: 20px;
  //     font-weight: normal;
  //     padding-top: 20px;
  //     margin-left: 6px;
  //   }
  // }

}

// testimonial - start

.left-testimonials-column {
  margin-right: 170px;
}
  
@media (max-width: 560px) {
  .left-testimonials-column {
    margin-right: 0px;
    margin: 12px;
    margin-bottom: 60px;
    margin-top: 0px;
  }
}

.testimonial-column-title {
  color: #ff7043;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-left: 12px;
  text-decoration: underline;
  text-decoration-color: var(--app-primary-color);
}

.testimonial-block {
  color: white;
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  align-items: center;
}

.testimonial-title {
  font-size: 20px;
  font-weight: bold;
}

.testimonial-subtitle {
  font-size: 14px;
  font-style: italic;
}

.testimonial-text {
  font-size: 16px;
  margin-top: 8px;
}

.testimonial-photo {
  width: 140px;
  height: 140px;
  margin: 12px;
  margin-right: 0px;
}

.testimonial-text-block {
  text-align: right;
}

.testimonial-block.left-aligned {
  align-self: flex-start;
}

.testimonial-block.left-aligned .testimonial-text-block {
  text-align: left;
}

.testimonial-block.left-aligned .testimonial-photo {
  margin: 12px;
  margin-left: 0px;
}

@media (max-width: 560px) {
  .testimonial-subtitle {
    font-size: 12px;
  }
}

// testimonial - end

// pricing column - start

.right-pricing-colum {
  width: 390px;
}

.pricing-block-main-title{
  align-self: flex-start;
  font-size: 34px;
  font-weight: bold;
  color: #ff7043;
  margin-bottom: 10px;
}

.pricing-block-main {
  align-self: flex-start;

  .pricing-terms-new {
    color: var(--color-white);
    font-size: 18px;
    margin-left: 14px;
  }

  .pricing-terms-new-item{
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-items: center;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .pricing-terms-new-item img {
    width: 16px; 
    height: 16px;
    padding-right: 6px;
  }
}

@media (max-width: 560px) {
  .right-pricing-colum {
    width: 90vw;
  }

  .pricing-block-main-title{
    font-size: 28px;
  }
}

.pricing-block-free-title {
  align-self: flex-start;
  font-size: 28px;
  font-weight: bold;
  color: #ff7043;
  margin-top: 50px;
}

.pricing-block-free {
  align-self: flex-start;

  .pricing-terms {
    color: var(--color-white);
    font-size: 18px;

    li {
      padding-bottom: 12px;
      list-style-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA2ElEQVQ4jZXSIU5DQRCH8Q0hDUGRhlQiUD0A4QCIHoC8cAxEBbIOQ4JCVXGAqmoEgiMgkNAgqhpSQQgCfoj3msAy0H3/ZNXO983sZlJqEfQxwWEbbgUn3KrzgWv02ghO/M6sFN7GcyAYlwrOA/gFuyXwPt4CwWlp92kA32MzL+wG8CCA4SgvrJoxL1cidPAQwJMc3sH8W8ECQ4wC+BV7uWD8x5hRRvkzN5rzWfCfTymli/AGB7hb0/34X7161ys8BvANCoasRVs4w7KB39Evo3+KeriyZuO+AAe5rp9zTADZAAAAAElFTkSuQmCC");
    }
  }
}

// pricing column - end

/* ========================= Page: features ======================= */

.page.features {
  background-color: #262838;
  align-items: center;

  .feature-container {
    max-width: 1324px;
  }

  .feature{
    min-width: 300px;
    padding-right: 30px;
    padding-left: 30px;
    color: white;

    margin-top: 120px;
    margin-bottom: 140px;

    // flex variables:
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .text-container {
    max-width: 430px;
  }

  .text-container.text-on-left-side {
    margin-right: 120px;
  }

  .text-container.text-on-right-side {
    margin-left: 120px;
  }

  .video-container iframe {
    width: 600px;
    height: calc(600px * (220 / 400));
  }

  .feature .card-title {
    color: #b2dfdb;
    margin-bottom: 20px; 
    font-size: 30px; 
    font-weight: bold
  }

  .feature .card-text {
    padding-top: 10px; 
    font-size: 17px;
  }

  .feature .card-text-small {
    padding-top: 10px;
    font-size: 11px;
    color: wheat;
  }

  .feature .card-a-tag {
    display: block;
    padding-top: 18px;
    color: #e1f5fe;
  }

  @media ( max-width: 1230px) {

    .text-container {
      max-width: 300px;
    }

    .video-container iframe {
      width: 300px;
      height: calc(300px * (220 / 400));
    }

    .text-container.text-on-left-side {
      margin-right: 20px;
    }

    .text-container.text-on-right-side {
      margin-left: 20px;
    }

    .feature .card-title{
      font-size: 22px;
    }

    .feature .card-text {
      font-size: 15px;
    }
  }

  @media ( max-width: 560px) {
    .feature {
      min-height: 0px;
      margin-top: 0px;
      margin-bottom: 60px;
      padding: 0px;
    }

    .video-container {
      margin-top: 40px;
      margin-bottom: 10px;
    }

    .video-container iframe {
      width: calc(100vw);
      height: calc(100vw * (220 / 400));
    }

    .text-container.text-on-left-side {
      margin-right: 0px;
    }

    .text-container.text-on-right-side {
      margin-left: 0px;
    }

    .text-container{
      padding-left: 20px;
      padding-right: 20px;
      max-width: unset;
    }

    .feature .card-title{
      font-size: 22px;
    }

    .feature .card-text {
      font-size: 15px;
    }

    .pos-feature {
      margin-top: 60px;
    }
  }
}


/* ========================= Page: Lite ======================= */

.page.lipi-lite {
  // background-color: #b6bad3;
  background-color: #262838;

  background-image: url("../assets/lipi-lite-screenshot.png");
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
}

.lipi-lite-container {
  max-width: 600px;
  text-align: left;
  // border: 1px solid yellow;
  padding: 20px 20px;

  margin-left: -400px;
}

@media (max-width: 1520px) {
  .page.lipi-lite {
    align-items: flex-start;
  }
  .lipi-lite-container {
    margin-left: 100px;
  }
}

@media (max-width: 1380px) {
  .page.lipi-lite {
    align-items: flex-start;
  }
  .lipi-lite-container {
    margin-left: 0px;
  }
}

@media (max-width: 1290px) {
  .page.lipi-lite {
    // align-items: center;
    // background-image: none;
    min-height: calc(60vh - 100px);
  }

  .lipi-lite-container {
    margin-left: 0px;
  }
}

@media (max-width: 1024px) {
  .page.lipi-lite {
    // align-items: center;
    // background-image: none;
    min-height: calc(60vh - 100px);
  }

  .lipi-lite-container {
    margin-left: 0px;
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .page.lipi-lite {
    // align-items: center;
    // background-image: none;
    min-height: calc(40vh - 100px);
  }

  .lipi-lite-container {
    margin-left: 0px;
    max-width: 400px;
  }
}

@media (max-width: 767px) {
  .page.lipi-lite {
    align-items: center;
    background-image: none;
    min-height: calc(100vh - 100px);
  }

  .lipi-lite-container {
    // margin-left: 0px;
    max-width: none;
  }
}

.lipi-lite-title {
  color: #e1f5fe;
  font-size: 40px;
  font-weight: bold;
}

.lipi-lite-body-one {
  color: white;
  margin-top: 20px;
  font-size: 20px;
}

.lipi-lite-body-two {
  color: var(--color-whitesmoke);
  font-size: 14px;
  margin-top: 20px;
}

.colored-body-text {
  color: #b2dfdb;
}

.lipi-lite-action-container {
  padding-top: 20px;
  margin-left: -20px;
}

/* ========================= Page: Join ======================= */

.page.join {
  background: linear-gradient(
    -135deg,
    #004D40 0%,
    #004D40 16%,
    white 16%,
    white 100%
  );
}

.page.join .join-us-container {
  margin: 12px;
  text-align: center;
  max-width: 400px;
}

.page.join .join-us-title {
  font-size: 16px;
  padding-bottom: 10px;
}

.page.join .join-us-detail .phone {
  font-size: 20px;
  font-weight: bold;
  line-height: 5px;
}

.page.join .join-us-detail .or {
  font-size: 15px;
  line-height: 0px;
}

.page.join .join-us-detail .email {
  font-size: 20px;
  font-weight: bold;
  line-height: 5px;
}

.page.join .join-us-container .view-app-container {
  //  border: 1px solid red; 
  margin-bottom: 20px;
  padding: 20px;
  font-size: 18px;
}

.social {
  img {
    height: 32px;
    margin-left: 6px;
    margin-right: 6px;
    margin-top: 26px;
    cursor: pointer;
  }
}

// member - start

.left-members-column {
  margin-right: 170px;
}
  
@media (max-width: 560px) {
  .left-members-column {
    margin-right: 0px;
    margin: 12px;
    margin-bottom: 30px;
    margin-top: 0px;
  }
}

.member-column-title {
  color: #ff7043;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-left: 12px;
  text-decoration: underline;
  text-decoration-color: var(--app-primary-color-light);
}

.member-block {
  color: var(--text-color);
  display: flex;
  flex-direction: row;
  align-self: flex-end;
  align-items: center;
}

.member-title {
  font-size: 20px;
  font-weight: bold;
}

.member-text {
  font-size: 14px;
}

.member-photo {
  width: 140px;
  height: 140px;
  // border: 6px solid red;
  margin: 12px;
}

.member-text-block {
  // margin-top: 12px;
}

// member - end

/* ========================= Footer ======================= */

.footer {
  text-align: center;
  font-size: 15px;
  color: var(--text-color-light);
  margin-bottom: 24px;
  margin-top: 24px;
  line-height: 160%;
  padding-left: 5px;
  padding-right: 5px;
}

</style>
<script>
export default {
  name: "lipi",

  metaInfo: {
    title: "Lipi for Business - POS, Accounting, Inventory",
    meta: [
      {
        name: "description",
        content:
          "ব্যবসার সকল দিক পরিচালনার জন্য সহজ একটি অ্যাপ - Lipi is easy-to-adopt in your business and easy-to-use daily"
      },
      {
        name: "keywords",
        content:
          "Lipi, POS, Point of Sale, ERP, Bangla ERP, SaaS, CRM, Accounting, Inventory, Business Management, Customer Management, Vendor Management, Android POS App, Android ERP, Cloud POS, Cloud ERP, Bangladesh, Bangladesh Startup"
      }
    ]
  },

  data() {
    return {
      verses: window.languageSets[window.defaultLanguage], // fallback,
      selectedLanguage: window.defaultLanguage,
      isPlatformAndroid: false,
      phone: '',
      placeholder: '01770947908'
    };
  },

  mounted: function() {

    this.phone = '';
    
    window.scrollTo(0, 0);

    // (String(navigator.platform).toLowerCase().indexOf('mac') === 0)
    let platform = String(navigator.platform).toLowerCase();
    this.isPlatformAndroid = (platform.indexOf('android') === 0) || ((platform.indexOf('linux') === 0) && (platform !== 'linux x86_64'));
    // this.isPlatformAndroid = true; // to test

    this.initLanguage();
    this.smartphoneWidthForFeatureSection = 800;

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function(e) {
        e.preventDefault();
        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });
  },

  methods: {
    scrollDownClicked(e){
      e.preventDefault();
      document.querySelector('#features').scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },

    getMobileAppClicked(e){
      e.preventDefault();
      document.querySelector('#lipi-lite').scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },

    registerClicked(){
      let url;
      if (this.phone){
        url = `https://app.lipi.live/#/register/phone:${this.phone}`;
      } else {
        url = `https://app.lipi.live/#/register`;
      }
      window.location.href = url;
      // window.location.assign(url);
    },

    setLanguage(key) {
      window.localStorage.setItem("--language", key);
      this.initLanguage();
    },

    initLanguage() {
      let key = window.localStorage.getItem("--language") || window.defaultLanguage;
      this.selectedLanguage = key;
      this.verses = window.languageSets[key];

      window.setTimeout(()=> {
        try {
          if (window.innerWidth >= this.smartphoneWidthForFeatureSection) {
            this.featureTapped(null, "retail");
          }
        } catch (ex){
          'pass'
        }
      }, 100);
    },

    featureTapped: function(event, selectedFeatureKey) {
      // console.log("featureTapped: ", selectedFeatureKey);

      this.$el.querySelectorAll(".feature-title").forEach(node => {
        node.classList.remove("selected");
      });

      let sourceEl = this.$el.querySelector(".default-feature-title");
      if (event) sourceEl = event.target;
      sourceEl.classList.add("selected");

      let el = this.$el.querySelector(
        `.feature-option[data-key=${selectedFeatureKey}]`
      );

      if (window.innerWidth < this.smartphoneWidthForFeatureSection) {
        // show modal
        let modalWidth = window.innerWidth - 80;

        let content = `
        <div style="padding-right: 20px; padding-left: 20px;">
          ${el.innerHTML}
          <div style="position: absolute; right: 12px; bottom: 12px;">
            <div @click="$emit('close')">❌</div>
          </div>
        </div>
        `;
        this.$modal.show(
          {
            template: content
          },
          {},
          {
            classes: ["v--modal", "feature-modal"],
            resizable: true,
            adaptive: true,
            maxWidth: modalWidth
          }
        );
      } else {
        // update div
        let target = this.$el.querySelector(`.feature-hero`);

        target.innerHTML = el.innerHTML;
      }
    }
  }
};
</script>
